import _ from 'lodash';
import { schemaShouldShowConfigTypes, schemaTypes } from '../outputSchema/config';
import { pipeInputSchemaTypes } from './config';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const isBasketEnabled = _.get(window, 'userPermissions.subscribedProPlan.isEnabled', false);
const { isCrypto, isAlgoverse } = ApplicationDomainUtility;

const configuration = {
  type: 'basket',
  defaults: {
    type: 'basket',
    name: 'basket',
    config: {
      legs: [],
      resetOnDayStart: false,
      when: [
        {
          leftOperand: '',
          operator: '',
          rightOperand: '',
          conditionOperator: 'and'
        }
      ],
    }
  },
  inputSchema: [
    {
      name: 'legs',
      type: pipeInputSchemaTypes.intents,
      label: 'Legs',
    },
    {
      name: 'when',
      type: pipeInputSchemaTypes.signal,
      label: 'When',
    },
    {
      name: 'resetOnDayStart',
      type: pipeInputSchemaTypes.select,
      label: 'Reset On DayStart',
      info: 'Reset On DayStart Content',
      options: [
        { label: 'True', value: true },
        { label: 'False', value: false }
      ],
      isDisplay: false
    }
  ],
  searchTerms: [
    'Basket',
    'Combined Premium',
    'Options Basket'
  ],
  configFormOptions: {
    valuePathEditable: true,
    configFieldOptions: {}
  },
  buildOutputSchema: (pipeConfig) => {
    const { name, type } = pipeConfig;

    const properties = [
      {
        name: `${name}.combinedPremium.close`,
        label: `${name} close`,
        isDisplay: true,
        type: schemaTypes.number,
      },
      {
        name: `${name}.combinedPremium.open`,
        label: `${name} open`,
        isDisplay: true,
        type: schemaTypes.number,
      },
      {
        name: `${name}.combinedPremium.high`,
        label: `${name} high`,
        isDisplay: true,
        type: schemaTypes.number,
      },
      {
        name: `${name}.combinedPremium.low`,
        label: `${name} low`,
        isDisplay: true,
        type: schemaTypes.number,
      },
      {
        name: `${name}.combinedPremium.durationSinceLastCapture`,
        label: `${name} durationSinceLastCapture`,
        isDisplay: false,
        type: schemaTypes.duration,
      },
      {
        name: `${name}.combinedPremium.isCapturedToday`,
        label: `${name} isCapturedToday`,
        isDisplay: false,
        type: schemaTypes.boolean,
      },
    ];

    return [
      {
        name: `${type}.${name}.combinedPremium`,
        type: schemaTypes.number,
        tagConfig: { tag: 'Combined Premium', color: '#FFA500' },
        indicatorType: type,
        category: 'indicator',
        label: name,
        shouldShowConfigs: [
          schemaShouldShowConfigTypes.pipeValuePath,
        ],
        priority: 70,
        schemaName: name
      },
      {
        name: `${type}.${name}.openInterest`,
        type: schemaTypes.number,
        tagConfig: { tag: 'Open Interest', color: '#FFA500' },
        indicatorType: type,
        category: 'indicator',
        label: `${name}`,
        shouldShowConfigs: [
          // schemaShouldShowConfigTypes.pipeValuePath,
        ],
        priority: 70,
        schemaName: name
      },
      ..._.map(properties, (property) => {
        const { name, type: propertieType, label, isDisplay } = property;
        if (!isDisplay) return null;
        return {
          name,
          type: propertieType,
          tagConfig: { tag: 'Combined Premium', color: '#FFA500' },
          indicatorType: type,
          category: 'indicator',
          label,
          shouldShowConfigs: [
            schemaShouldShowConfigTypes.entryLeftOperand,
            schemaShouldShowConfigTypes.entryRightOperand,
            schemaShouldShowConfigTypes.exitLeftOperand,
            schemaShouldShowConfigTypes.exitRightOperand,
            schemaShouldShowConfigTypes.adjustmentLeftOperand,
            schemaShouldShowConfigTypes.adjustmentRightOperand,
          ],
          priority: 70,
          schemaName: name
        };
      })
    ];
  },
  isEnabled: !(isAlgoverse || isCrypto),
  isAccessible: isBasketEnabled
};
export default configuration;
